/* Luxury System JS — lightweight and Dawn-safe (META ADS OPTIMIZED)
   Adds a single body class on scroll for stable header styling.
   OPTIMIZOVANO: Ubačen "State Tracker" kako bi se eliminisalo konstantno pingovanje DOM-a tokom skrolanja.
*/
(function(){
  const body = document.body;
  let ticking = false;
  let isScrolled = false; // Memorija koja čuva stanje

  function onScroll(){
    if(ticking) return;
    ticking = true;
    
    window.requestAnimationFrame(function(){
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      const shouldBeScrolled = y > 12;

      // OPTIMIZACIJA: Dodirujemo teški DOM elemenat *samo* onog trenutka kada se stanje prelomi (0-12px)
      if (isScrolled !== shouldBeScrolled) {
        isScrolled = shouldBeScrolled;
        
        if (isScrolled) {
          body.classList.add('lux-scrolled');
        } else {
          body.classList.remove('lux-scrolled');
        }
      }
      
      ticking = false;
    });
  }

  // passive: true je već odlična praksa za performanse skrola
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();